module.exports = __webpack_public_path__ + "img/bg-next-memo.771a47b1.png";